module.exports = "div.accordion>h3:before {\n    display: none;\n}"